// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table_tableContainer__DdR1B","button":"Table_button__68gAy","destructive":"Table_destructive__elCqz"};